import { motion } from "framer-motion";
import { Box, Button, HStack, VStack } from "native-base";

export const Animated = {
  Button: motion(Button),
  Box: motion(Box),
  VStack: motion(VStack),
  HStack: motion(HStack),
};
